module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av64-a7d7743a9519d91af3d839eb63a76c86.jpg";